/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const RefundCardStatus = {
  Initiated: "initiated",
  Confirmed: "confirmed",
  Settled: "settled",
  Failed: "failed",
  Completed: "completed",
} as const;
export type RefundCardStatus = ClosedEnum<typeof RefundCardStatus>;

/** @internal */
export const RefundCardStatus$inboundSchema: z.ZodNativeEnum<
  typeof RefundCardStatus
> = z.nativeEnum(RefundCardStatus);
/** @internal */
export const RefundCardStatus$outboundSchema: z.ZodNativeEnum<
  typeof RefundCardStatus
> = RefundCardStatus$inboundSchema;
